
import React, { useEffect, useState } from 'react';
import { DefaultButton, IButtonStyles, IDropdownOption, MessageBar, MessageBarType } from '@fluentui/react';
import peripheralService from "../../../../../services/peripheral.service";
import { IChoiceField, IField, IFile, IScanner, IScanRequestModel } from '../../../../../shared/interfaces';
import { reduxActions, RootState } from '../../../../../store'
import { store } from '../../../../../index';
import { useSelector } from 'react-redux';
import DynamicForm from '../../../../DynamicForm/DynamicForm';
import { useBoolean } from '@fluentui/react-hooks';
import RippleLoader from '../../../../Loader/RippleLoader/RippleLoader';
import { Wizard_Mode } from '../../../../../shared/enums';
import protocolsService from '../../../../../services/protocols.service';



const uploadButtonStyles: Partial<IButtonStyles> = {
    root: {
        marginTop: 15
    }
}



export interface FromScannerProps {
    target: string
    onFileChanged?: () => void;
}

type Props = FromScannerProps

const FromScanner: React.FunctionComponent<Props> = props => {

    const selectArxeiaConfigurations = (state: RootState) => state.sessionReducer.arxeiaConfigurations;
    const currentArxeiaConfigurations = useSelector(selectArxeiaConfigurations);

    const selectCurrentAoo = (state: RootState) => state.sessionReducer.currentAoo;
    const currentAoo = useSelector(selectCurrentAoo);

    const selectCurrentUor = (state: RootState) => state.sessionReducer.currentUor;
    const currentUor = useSelector(selectCurrentUor);

    const selectCurrentProtocol = (state: RootState) => state.protocolWizardReducer.protocol;
    const currentProtocol = useSelector(selectCurrentProtocol);

    const selectWizardMode = (state: RootState) => state.protocolWizardReducer.wizardMode;
    const wizardMode = useSelector(selectWizardMode);

    const selectDocumentScannerFields = (state: RootState) => state.protocolWizardReducer.documentScannerFields;
    const documentScannerFields = useSelector(selectDocumentScannerFields);

    const selectAttachmentScannerFields = (state: RootState) => state.protocolWizardReducer.attachmentScannerFields;
    const attachmentScannerFields = useSelector(selectAttachmentScannerFields);

    const selectScannerDocumentLoader = (state: RootState) => state.protocolWizardReducer.documentScannerLoader;
    const documentScannerLoader = useSelector(selectScannerDocumentLoader);

    const selectScannerAttachmentLoader = (state: RootState) => state.protocolWizardReducer.attachmentScannerLoader;
    const attachmentScannerLoader = useSelector(selectScannerAttachmentLoader);

    const [listScanners, setListScanners] = useState<IScanner[]>([]);

    const [messageBarIsVisible, { setTrue: showMessageBar, setFalse: dismissMessageBar }] = useBoolean(false);
    const [messageBarType, setMessageBarType] = useState<MessageBarType>();
    const [messageBarText, setMessageBarText] = useState<string>('');

    const [isScanButtonEnabled, { setTrue: enableScanButton, setFalse: disableScanButton }] = useBoolean(false);

    const setLoader = (showLoader: boolean) => props.target === 'documento'
        ? store.dispatch(reduxActions.protocolWizardActions.setDocumentScannerLoader(showLoader))
        : store.dispatch(reduxActions.protocolWizardActions.setAttachmentScannerLoader(showLoader));

    const [cancelTokenSources, setCancelTokenSources] = useState<any>({});

    //useEffect(() => {
    //    // Anything in here is fired on component mount.


    //    return () => {
    //        // Anything in here is fired on component unmount.

    //        // cancello tutte le request in pending
    //        for (const [key, value] of Object.entries<CancelTokenSource>(cancelTokenSources)) {
    //            value.cancel(`${key} canceled`)
    //        }

    //    }
    //}, [])


    useEffect(() => {

        if (currentArxeiaConfigurations) {
            let peripheralServiceBaseUrl = currentArxeiaConfigurations.find(el => el.key === "PeripheralServiceBaseUrl")
            if (peripheralServiceBaseUrl && peripheralServiceBaseUrl.value && peripheralServiceBaseUrl.value !== '-') {
                peripheralService.setPeripheralServiceBaseUrl(peripheralServiceBaseUrl.value);

                peripheralService.getScanners()
                    .then(result => {

                        const updatedFields = props.target === "documento"
                            ? [...documentScannerFields]
                            : [...attachmentScannerFields];

                        let _listScanners: IDropdownOption[] = result.map((el, index) => {
                            return { key: el.sourceId, text: el.sourceName };
                        });

                        // Ottieni le opzioni correnti nel campo "sourceName"
                        let sourceNameField = updatedFields.find(el => el.internalName === 'sourceName') as IChoiceField;

                        // Controlla se le nuove opzioni sono le stesse delle opzioni correnti
                        let areOptionsSame = sourceNameField && sourceNameField.options.length === _listScanners.length &&
                            sourceNameField.options.every((option, index) => option.key === _listScanners[index].key && option.text === _listScanners[index].text);

                        // Se le opzioni non sono le stesse, aggiornale
                        if (!areOptionsSame) {
                            updateListOptions(updatedFields, 'sourceName', _listScanners);
                        }

                        let partialProtocolWizrdState = props.target === "documento"
                            ? { documentScannerFields: updatedFields }
                            : { attachmentScannerFields: updatedFields };

                        store.dispatch(reduxActions.protocolWizardActions.updateProtocolWizardState(partialProtocolWizrdState));

                        setListScanners(result);

                        if (result.length === 0) {
                            setMessageBarText("Nessuno scanner disponibile");
                            setMessageBarType(MessageBarType.error);
                            showMessageBar();
                        }
                        else {
                            //recupero scanner default (se presente)                            
                            let scannerDefault : IScanner = result.find(el => el.isDefault === true)!;
                            if (scannerDefault) {
                                updateListOptions(updatedFields, 'sourceName', _listScanners, scannerDefault?.sourceId!);
                                loadScannerProperties(scannerDefault, updatedFields);
                                dispatchWizrdState(updatedFields);
                                canEnableScanButton(updatedFields, result);
                            }
                        }

                    },
                        error => {
                            if (!error.isErrorShown) {
                                setMessageBarText("Servizio scanner non configurato correttamente");
                                setMessageBarType(MessageBarType.error);
                                showMessageBar();
                            }
                        });
            }
            else {
                setMessageBarText('Servizio scanner non configurato correttamente');
                setMessageBarType(MessageBarType.error);
                showMessageBar();

            }
        }
    }, [currentArxeiaConfigurations]);


    const inputChangedHandler = (updatedField: IField) => {

        const updatedFields = props.target === "documento"
            ? [...documentScannerFields]
            : [...attachmentScannerFields];
        let updatedFieldIndex = updatedFields.findIndex(el => el.internalName === updatedField.internalName);
        updatedFields[updatedFieldIndex] = { ...updatedField };

        //seleziono uno scanner
        if (updatedField.internalName === 'sourceName') {
            let selectedScannerOption = listScanners.find(el => el.sourceId === updatedField.internalValue);
            if (selectedScannerOption) {
                loadScannerProperties(selectedScannerOption, updatedFields);
            }
            else {
                let _listColors: IDropdownOption[] = [];
                updateListOptions(updatedFields, 'pixelType', _listColors);
                let _listDuplex: IDropdownOption[] = [];
                updateListOptions(updatedFields, 'duplex', _listDuplex);
                let _listDPI: IDropdownOption[] = [];
                updateListOptions(updatedFields, 'resolution', _listDPI);

                dispatchWizrdState(updatedFields);
            }
        }
        else {
            dispatchWizrdState(updatedFields);

        }

        canEnableScanButton(updatedFields, listScanners);
    }

    const dispatchWizrdState = (updatedFields: IField[]) => {

        let partialProtocolWizrdState = props.target === "documento"
            ? { documentScannerFields: updatedFields }
            : { attachmentScannerFields: updatedFields };

        store.dispatch(reduxActions.protocolWizardActions.updateProtocolWizardState(partialProtocolWizrdState));
    }

    const loadScannerProperties = (selectedScanner: IScanner, updatedFields: IField[]) =>{
        let defaultValue:any = undefined;
        let _listColors: IDropdownOption[] = [];
        if (selectedScanner && selectedScanner.pixelType) {

            let entries = Object.entries(selectedScanner.pixelType) as any[];
            _listColors = entries.map(([k, value]) => {
                return { key: k, text: value.toString() }
            });
            defaultValue = _listColors.find(el => el.key == selectedScanner.pixelTypeDefault);
        }
        else {
            _listColors.push({ text: "B/N", key: 0 });
            defaultValue = "0";
        }
        updateListOptions(updatedFields, 'pixelType', _listColors, defaultValue?.key.toString()!);

        let _listDuplex: IDropdownOption[] = [];
        if (selectedScanner && selectedScanner.duplex) {
            let entries = Object.entries(selectedScanner.duplex) as any[];
            _listDuplex = entries.map(([k, value]) => {
                return { key: k, text: value }
            });
            defaultValue = _listDuplex.find(el => el.key == selectedScanner.duplexDefault);

        }
        else {
            _listDuplex.push({ text: "No", key: "0" });
            defaultValue = "0";
        }
        updateListOptions(updatedFields, 'duplex', _listDuplex, defaultValue?.key);

        let _listDPI: IDropdownOption[] = [];
        if (selectedScanner && selectedScanner.resolution) {
            let entries = Object.entries(selectedScanner.resolution) as any[];
            _listDPI = entries.map(([k, value]) => {
                return { key: k, text: value }
            });
            defaultValue = _listDPI.find(el => el.key == selectedScanner.resolutionDefault)!;

        }
        else {
            _listDPI.push({ text: "200", key: 0 })
            defaultValue = "0";
        }
        updateListOptions(updatedFields, 'resolution', _listDPI, defaultValue?.key.toString()!);


        let partialProtocolWizrdState = props.target === "documento"
            ? { documentScannerFields: updatedFields }
            : { attachmentScannerFields: updatedFields };

        store.dispatch(reduxActions.protocolWizardActions.updateProtocolWizardState(partialProtocolWizrdState));
        setMessageBarText("");
        setMessageBarType(MessageBarType.error);
        dismissMessageBar();
    }

    const loadScannerCapabilities = (scannerName: string, updatedFields: IField[]) => {

        peripheralService.loadScannerCapabilities(scannerName)
            .then(selectedScanner => {
                loadScannerProperties(selectedScanner, updatedFields);
            },
                error => {
                    if (!error.isErrorShown) {
                        let _listColors: IDropdownOption[] = [];
                        updateListOptions(updatedFields, 'pixelType', _listColors);
                        let _listDuplex: IDropdownOption[] = [];
                        updateListOptions(updatedFields, 'duplex', _listDuplex);
                        let _listDPI: IDropdownOption[] = [];
                        updateListOptions(updatedFields, 'resolution', _listDPI);

                        let partialProtocolWizrdState = props.target === "documento"
                            ? { documentScannerFields: updatedFields }
                            : { attachmentScannerFields: updatedFields };

                        store.dispatch(reduxActions.protocolWizardActions.updateProtocolWizardState(partialProtocolWizrdState));

                        setMessageBarText("Propriet\u00e0 scanner non disponibili");
                        setMessageBarType(MessageBarType.error);
                        showMessageBar();
                    }
                });



    }

    const canEnableScanButton = (_fields: IField[], scanners: IScanner[]) => {
        let sourceName = _fields.find(el => el.internalName === 'sourceName')?.internalValue;
        let _selectedScannerOption = scanners.find(el => el.sourceId === sourceName);
        let _pixelType = _fields.find(el => el.internalName === 'pixelType')?.internalValue;
        let _resolution = _fields.find(el => el.internalName === 'resolution')?.internalValue;
        if (_selectedScannerOption && _pixelType && _resolution) {
            enableScanButton();
        }
        else {
            disableScanButton();
        }

    }

    const updateListOptions = (fields: IField[], fieldInternalName: string, newList: IDropdownOption<any>[], defaultValue: any = null) => {
        let filedIndex = fields.findIndex(el => el.internalName == fieldInternalName);
        if (filedIndex >= 0) {
            let field = { ...fields[filedIndex] } as IChoiceField;
            field.options = newList;
            field.internalValue = defaultValue;
            fields[filedIndex] = { ...field };
        }
    }

    const onScanButtonClick = () => {
        const scannerFields = props.target === "documento"
            ? [...documentScannerFields]
            : [...attachmentScannerFields];

        let sourceName = scannerFields.find(el => el.internalName === 'sourceName')?.internalValue;
        let _selectedScannerOption = listScanners.find(el => el.sourceId === sourceName);
        let _pixelType = scannerFields.find(el => el.internalName === 'pixelType')?.internalValue;
        let _duplex = scannerFields.find(el => el.internalName === 'duplex')?.internalValue === "1" ? true : false;
        let _resolution = scannerFields.find(el => el.internalName === 'resolution')?.internalValue;
        if (_selectedScannerOption && _pixelType && _resolution) {
            let scanRequestModel: IScanRequestModel = {
                sourceId: Number(_selectedScannerOption!.sourceId),
                sourceName: _selectedScannerOption!.sourceName,
                pixelType: Number(_pixelType),
                duplex: _duplex,
                resolution: Number(_resolution),
                size: 1, // formato A4
                signatureAX: undefined
            };
            setLoader(true);
            if (wizardMode === Wizard_Mode.Allocated && props.target === "documento") {
                protocolsService.getSignatureForProtocol(currentAoo!.id, currentUor!.id!, currentProtocol.protocolId!)
                    .then(signature => {
                        scanRequestModel.signatureAX = signature;
                        avviaScansione(scanRequestModel);
                    },
                        error => {

                            if (!error.isErrorShown) {
                                setMessageBarText("Errore durante l'acquisizione della firma");
                                setMessageBarType(MessageBarType.error);
                                showMessageBar();
                            }
                            setLoader(false);

                        });
            }
            else {
                avviaScansione(scanRequestModel);
            }
        }
    };


    const avviaScansione = (scanRequestModel: IScanRequestModel) => {
        peripheralService.scan(scanRequestModel)
            .then(result => {
                getScanDocument(result);
                setLoader(false);
            })
            .catch(error => {

                if (!error.isErrorShown) {
                    setMessageBarText("Errore durante l'acquisizione da scanner");
                    setMessageBarType(MessageBarType.error);
                    showMessageBar();
                }
                setLoader(false);


            });
    }

    const getScanDocument = (base64str) => {
        const byteCharacters = atob(base64str);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });

        //generazione nome casuale del file
        let suffix = Math.random().toString(36).slice(2, 7);
        let randomFileName = "Scan_" + suffix + ".pdf";

        const fileFromScan = new File([blob], randomFileName, { type: 'application/pdf' });

        const docFile: IFile = {
            fileName: randomFileName,
            extension: ".pdf",
            fileType: "Documento",
            docBase64String: undefined, // Non salviamo base64
            dimension: byteArray.length / 1000,
            dimensionUnit: "KB",
            enabled: true,
            file: fileFromScan // Salva il File object
        };


        switch (props.target) {
            case 'documento':
                store.dispatch(reduxActions.protocolWizardActions.setProtocol({ documentFile: docFile }));
                store.dispatch(reduxActions.protocolWizardActions.setProtocolWizardTouched());
                break;
            case 'allegati':
                if (currentProtocol?.attachments && currentProtocol?.attachments?.findIndex(el => el.fileName === docFile.fileName) < 0) {
                    store.dispatch(reduxActions.protocolWizardActions.addAttachment(docFile));
                    store.dispatch(reduxActions.protocolWizardActions.setProtocolWizardTouched());
                }
                break;
        }
        if (props.onFileChanged) {
            props.onFileChanged();
        }
    }

    return (

        <React.Fragment>
            <div className={`loader opacity ${(props.target === "documento" ? documentScannerLoader : attachmentScannerLoader) ? "active" : ''}`}>
                <RippleLoader text='Scansione in corso' />
            </div>

            {messageBarIsVisible &&
                <MessageBar
                    messageBarType={messageBarType}
                    isMultiline={false}
                    onDismiss={dismissMessageBar}
                    dismissButtonAriaLabel="Close">{messageBarText}</MessageBar>
            }

            <DynamicForm
                fields={props.target === "documento" ? documentScannerFields : attachmentScannerFields}
                extraCssClass=""
                onInputChangedHandler={(newField) => { inputChangedHandler(newField) }}
            />




            <DefaultButton
                text="Avvia scansione"
                onClick={onScanButtonClick}
                allowDisabledFocus
                styles={uploadButtonStyles}
                disabled={!isScanButtonEnabled}
            />


        </ React.Fragment>)
};


export default FromScanner;


